module.exports = __webpack_public_path__ + "img/1.4f6087ad.png";